module.exports = __webpack_public_path__ + "static/media/стандарт-мини.873c06d1.jpg";